import { useEffect, useState } from 'react';

/**
 * True when `active` has held for `delayMs` without any interaction.
 * Used to reduce the wall to "only Anna, the time and one ambient line".
 */
export function useIdleCalm(active: boolean, delayMs = 5000): boolean {
  const [calm, setCalm] = useState(false);

  useEffect(() => {
    if (!active) {
      setCalm(false);
      return;
    }
    let timer = window.setTimeout(() => setCalm(true), delayMs);
    const wake = () => {
      setCalm(false);
      window.clearTimeout(timer);
      timer = window.setTimeout(() => setCalm(true), delayMs);
    };
    window.addEventListener('pointerdown', wake);
    window.addEventListener('pointermove', wake);
    window.addEventListener('keydown', wake);
    return () => {
      window.clearTimeout(timer);
      window.removeEventListener('pointerdown', wake);
      window.removeEventListener('pointermove', wake);
      window.removeEventListener('keydown', wake);
    };
  }, [active, delayMs]);

  return calm;
}
